"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetShootsForLocationReminderResultSchema = void 0;
const joi_1 = __importDefault(require("joi"));
const CustomerSchema_1 = require("../../business/CustomerSchema");
const OrderSchema_1 = require("../../business/OrderSchema");
const ShootSchema_1 = require("../../business/ShootSchema");
exports.GetShootsForLocationReminderResultSchema = joi_1.default.object({
    shoot: ShootSchema_1.ShootSchema.required(),
    order: OrderSchema_1.OrderSchema.required(),
    customer: CustomerSchema_1.CustomerSchema.required()
}).meta({ className: 'GetShootsForLocationReminderResult' });
//# sourceMappingURL=GetShootsForLocationReminderResultSchema.js.map